import { useNavigate } from "react-router-dom";
import { ApplicationFeature } from "@green0meter/api-client";
import { isEmpty } from "lodash";

import { useGetCurrentCompanyInfo, useGetProcurementSupplierHubs } from "@api";
import { useUserStore } from "@store/user";
import { hasOnlyFeature } from "@helpers";

export const useNavigateAfterLogin = (): (() => Promise<void>) => {
  const navigate = useNavigate();
  const { user } = useUserStore();
  const { currentCompanyInfo, refetchCurrentCompanyInfo } =
    useGetCurrentCompanyInfo(user);
  const { hubs, isPendingProcurementSupplierHubs, refetchHubs } =
    useGetProcurementSupplierHubs();

  return async () => {
    try {
      const redirectUrl = sessionStorage.getItem("redirectAfterLogin");

      if (redirectUrl) {
        sessionStorage.removeItem("redirectAfterLogin");
        navigate(redirectUrl);

        return;
      }

      const company = currentCompanyInfo ?? (await refetchCurrentCompanyInfo()).data;

      const isOnlySupplier = hasOnlyFeature(
        company?.companyFeatureFunctionalities,
        ApplicationFeature.PROCUREMENT_SUPPLIER,
      );

      if (isOnlySupplier) {
        // Ensure hubs are loaded before redirecting
        let loadedHubs = hubs;

        // Fallback: Refetch if data fetch is pending or no hubs available - optimize fetching logic to ensure hub data is available
        if (!loadedHubs || isPendingProcurementSupplierHubs) {
          loadedHubs = (await refetchHubs())?.data;
        }

        if (!isEmpty(loadedHubs) && loadedHubs) {
          // Redirect to the first available supplier hub
          navigate(`/suppliers-hub/${loadedHubs[0].procurementId}`);

          return;
        }
      }

      // Default redirect to home
      navigate("/");
    } catch (error) {
      console.error("Redirect failed:", error);
      navigate("/");
    }
  };
};
